import axios from "axios";

import { API_BASE_URL } from "../constants";
import { AuthorizationOutput, AuthorizationInput, BaseUser } from "../../../src/types";

const getAccessToken = () => {
    return window.localStorage.getItem('auth:accesstoken');
}

const setAccessToken = (token: string) => {
    window.localStorage.setItem('auth:accesstoken', token);
}

const removeAccessToken = () => {
    window.localStorage.removeItem('auth:accesstoken')
}

const signin = async (credentials: AuthorizationInput) => {
    const {data:{ token, user }} = await axios.post<AuthorizationOutput>(
        `${API_BASE_URL}/users/authorize`,
        credentials
    );
    setAccessToken(token);
    return user
};

const getAuthorizedUser = async () => {
    const { data: authorizedUser } = await axios.get<BaseUser>(`${API_BASE_URL}/users/authorized`)
    return authorizedUser;
}

const addTokenInterceptor = () => {
    axios.interceptors.request.use(function (config) {
        const token = getAccessToken()
        config.headers.authorization = `bearer ${token}`;
      
        return config;
    });
}

const service = { signin, getAuthorizedUser, removeAccessToken, addTokenInterceptor }

export default service;